import cn from 'clsx'

import { ImageBox } from 'shared-components'

import s from './Awards.module.sass'

function Awards({ project }: any) {
    const { awards, additionalAwards, secondaryImage } = project

    const { title, items } = awards || {}

    if (!items) return null

    return (
        <section className={s.Awards}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.AwardsCont}>
                    <div className={s.AwardsRow}>
                        <div className={s.AwardsTitle}>
                            {title && (
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: title,
                                    }}
                                />
                            )}
                        </div>
                        {items && (
                            <div className={s.AwardsList}>
                                {items?.map((item: any, index: number) => {
                                    const { awardStatus, title } = item || {}

                                    return (
                                        <div className={s.AwardItem} key={index}>
                                            {awardStatus && (
                                                <span
                                                    className="smallCaps"
                                                    dangerouslySetInnerHTML={{
                                                        __html: awardStatus,
                                                    }}
                                                />
                                            )}
                                            {title && (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: title,
                                                    }}
                                                />
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                    {additionalAwards &&
                        additionalAwards?.length > 0 &&
                        additionalAwards?.map((award: any, index: number) => {
                            const { title, items } = award || {}

                            return (
                                <div className={s.AwardsRow} key={index}>
                                    <div className={s.AwardsTitle}>
                                        {title && (
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: title,
                                                }}
                                            />
                                        )}
                                    </div>
                                    {items && (
                                        <div className={s.AwardsList}>
                                            {items.map((item: any, index: number) => {
                                                const { awardStatus, title } = item || {}

                                                return (
                                                    <div className={s.AwardItem} key={index}>
                                                        {awardStatus && (
                                                            <span
                                                                className="smallCaps"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: awardStatus,
                                                                }}
                                                            />
                                                        )}
                                                        {title && (
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: title,
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                </div>
                <div className={s.SecondaryImage}>{secondaryImage && <ImageBox image={secondaryImage} />}</div>
            </div>
        </section>
    )
}

export default Awards
